import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import { noop } from 'helpers/GlobalHelper';
import style from './SignUpModal.module.scss';

const SignUpModalContainer = props => {
  const { closeModal } = props;

  const { externalSimplifiedSignUpURL } = window.ExternalConfig;

  const closeIcon = <Icon onClick={() => closeModal()} color="white" icon="close" size="large" />;

  const handleIframeClose = e => {
    if (e.data === 'close') {
      closeModal();
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleIframeClose);
  });

  return (
    <div className={style.SignUpModal}>
      <div className={style.IconWrapper} onClick={() => closeModal()}>
        {closeIcon}
      </div>
      <iframe title="simplePurchaseFlow" src={externalSimplifiedSignUpURL} />
    </div>
  );
};

SignUpModalContainer.defaultProps = {
  closeModal: noop,
};

SignUpModalContainer.propTypes = {
  closeModal: PropTypes.func,
};

export default SignUpModalContainer;
